import React, { useEffect, useRef } from "react";

/**
 * props:
 * - open (bool)
 * - initialText (string)
 * - onSave(text) -> called with trimmed text
 * - onCancel()
 */
const CommentModal = ({ open, initialText = "", onSave, onCancel }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (open && textareaRef.current) textareaRef.current.focus();
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-80 shadow-xl">
        <h2 className="text-lg font-semibold mb-3">Add Comment</h2>
        <textarea ref={textareaRef} id="commentInput" defaultValue={initialText} className="w-full border border-gray-300 rounded p-2 h-24" />
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 bg-gray-300 rounded">
            Cancel
          </button>
          <button
            onClick={() => {
              const val = textareaRef.current ? textareaRef.current.value.trim() : "";
              onSave(val);
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommentModal;
